import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWH508F1 (請款單核准-主管)
// backend/modules/pwh508f1/models/models.go is the source of truth;
// field names/shapes here are copied verbatim, not guessed.
// ============================================================

export interface QueueItem {
  fh110_01: string;  // 請款單號 C(6)
  fh110_11: string;  // 請款日期
  fh110_22: string;  // 請款類別 C(1)
  fh110_221: string; // 請款類別名稱（後端計算欄，直接顯示不再推導）
  fh110_16: string;  // 公司代號 C(12)
  fh110_37: string;  // 部門代碼 C(4)
  fh110_801: string; // 目標核准層級（後端計算欄）
  fh110_802: string; // 核准層級顯示名稱（後端計算欄，直接顯示不再推導）
}

export interface QueueResponse {
  items: QueueItem[];
  total: number;
}

export interface ApproveResultItem {
  doc_key: string;
  success: boolean;
  message?: string;
}

export interface ApproveResponse {
  results: ApproveResultItem[];
}

// ============================================================
// API methods — GET /api/pwh508/queue, POST /api/pwh508/approve
// (backend/routes/pwh508f1_routes.go — only these two endpoints exist)
// ============================================================

export const pwh508Api = {
  /** Query the supervisor approval queue within an optional FH110_01 range */
  async queryQueue(startNo: string, endNo: string): Promise<QueueResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params.start_no = startNo.trim();
    if (endNo.trim()) params.end_no = endNo.trim();
    const res = await apiClient.get<QueueResponse>('/api/pwh508/queue', { params });
    return res.data;
  },

  /**
   * Batch-approve selected payment requests. `confirmed` must be true or
   * the backend rejects the whole call with 422
   * (PWH508-VAL-APPROVE-CONFIRM-DIALOG) with zero DB mutation.
   */
  async approve(items: string[], comment?: string): Promise<ApproveResponse> {
    const res = await apiClient.post<ApproveResponse>('/api/pwh508/approve', {
      items,
      confirmed: true,
      ...(comment ? { comment } : {}),
    });
    return res.data;
  },
};
